const getAddress = (eventTarget) => {
  let path = eventTarget.pathname + eventTarget.search
  if (path[0] !== '/') {
    path = '/' + path;
  }
  return path;
};

export default getAddress;